import { SourceSpecification } from "maplibre-gl";
import { fetchPostalCodePolygonData } from "../data/PostalCodePolygonData.js";
import { AppState } from "../AppState.js";

export async function getPostalCodePolygonSource(): Promise<SourceSpecification> {
	const state = new AppState();
	const postalCode = state.postalCode;
	const proxyUrl = state.proxyUrl;

	const postalCodePolygonFeature = await fetchPostalCodePolygonData(proxyUrl, postalCode);

	if (!postalCodePolygonFeature) {
		throw new Error("Postal code polygon is undefined");
	}

	return {
		type: "geojson",
		data: {
			type: "Feature",
			geometry: {
				type: "MultiPolygon",
				coordinates: postalCodePolygonFeature.geometry.coordinates,
			},
			properties: {
				postalCode: postalCodePolygonFeature.properties.postalCode,
				postalName: postalCodePolygonFeature.properties.postalName,
				municipality: postalCodePolygonFeature.properties.municipality,
			},
		},
	};
}
